import { FilterType } from 'components/entityViewer/entitiesDropDownFilter/entityFilterControls/FilterType';

export const ALL_FC_TRANSFER_ITEMS_FILTER_QUERY_KEYS = Object.freeze({
    FACILITIES: 'facilities',
    TRANSFER_STATUSES: 'transferStatuses',
    COMPANY_SOURCES: 'companySources',
});

export const sourceFacilityFilterConfig = {
    key: 'sourceFacilityId',
    label: 'Source FC',
    type: FilterType.SELECT,
    enableSearch: true,
    multi: true,
    options: [],
    deletable: true,
    remoteOptions: {
        queryId: ALL_FC_TRANSFER_ITEMS_FILTER_QUERY_KEYS.FACILITIES,
    },
    menuProps: {
        placeholder: 'Search FCs...',
        mergeWithStaticOptions: false,
    },
};

export const destinationFacilityFilterConfig = {
    key: 'destinationFacilityId',
    label: 'Destination FC',
    type: FilterType.SELECT,
    enableSearch: true,
    multi: true,
    options: [],
    deletable: true,
    remoteOptions: {
        queryId: ALL_FC_TRANSFER_ITEMS_FILTER_QUERY_KEYS.FACILITIES,
    },
    menuProps: {
        placeholder: 'Search FCs...',
        mergeWithStaticOptions: false,
    },
};

export const transferIdFilterConfig = {
    key: 'transferId',
    label: 'Transfer ID',
    type: FilterType.TEXT,
    deletable: true,
    inputProps: {
        placeholder: 'Enter transfer ID…',
    },
};

export const companySourceIdFilterConfig = {
    key: 'companySourceId',
    label: 'Company Source',
    type: FilterType.SELECT,
    enableSearch: true,
    multi: true,
    options: [],
    deletable: true,
    remoteOptions: {
        queryId: ALL_FC_TRANSFER_ITEMS_FILTER_QUERY_KEYS.COMPANY_SOURCES,
    },
    menuProps: {
        placeholder: 'Search company sources…',
        mergeWithStaticOptions: false,
    },
};

export const externalSkuFilterConfig = {
    key: 'externalSku',
    label: 'External SKU',
    type: FilterType.TEXT,
    deletable: true,
    inputProps: {
        placeholder: 'Enter SKU…',
    },
};

export const sourceLotIdFilterConfig = {
    key: 'sourceLotId',
    label: 'Source Lot ID',
    type: FilterType.TEXT,
    deletable: true,
    inputProps: {
        placeholder: 'Enter lot ID…',
    },
};

/** Multi-select — API accepts repeated `transferStatus[]` strings. */
export const transferStatusFilterConfig = {
    key: 'transferStatus',
    label: 'Transfer Status',
    type: FilterType.SELECT,
    enableSearch: true,
    multi: true,
    options: [],
    deletable: true,
    remoteOptions: {
        queryId: ALL_FC_TRANSFER_ITEMS_FILTER_QUERY_KEYS.TRANSFER_STATUSES,
    },
    menuProps: {
        placeholder: 'Select status…',
        mergeWithStaticOptions: false,
    },
};

export const transferItemStatusFilterConfig = {
    key: 'transferItemStatus',
    label: 'Item Status',
    type: FilterType.SELECT,
    multi: false,
    deletable: true,
    options: [
        { value: 'PENDING', label: 'PENDING' },
        { value: 'COMPLETED', label: 'COMPLETED' },
    ],
};

export const hasDiscrepancyFilterConfig = {
    key: 'hasDiscrepancy',
    label: 'Has Discrepancy',
    type: FilterType.SELECT,
    multi: false,
    deletable: true,
    options: [
        { value: 'true', label: 'Yes' },
        { value: 'false', label: 'No' },
    ],
};

/**
 * Merch all-FC transfer **items** filter dropdown order (matches API query params).
 */
export const AllFCTransferItemsFilterConfigArray = [
    sourceFacilityFilterConfig,
    destinationFacilityFilterConfig,
    transferIdFilterConfig,
    companySourceIdFilterConfig,
    externalSkuFilterConfig,
    sourceLotIdFilterConfig,
    transferStatusFilterConfig,
    transferItemStatusFilterConfig,
    hasDiscrepancyFilterConfig,
];

/** @type {import('shared/utils/filterTransformers').FilterTransformConfig} */
export const AllFCTransferItemsTransformConfig = {
    booleanKeys: ['hasDiscrepancy'],
    /** Multi TEXT chips + multi SELECT ids → number[] for API / URL round-trip. */
    numericArrayKeys: [
        'transferId',
        'externalSku',
        'sourceLotId',
        'sourceFacilityId',
        'destinationFacilityId',
        'companySourceId',
    ],
    /** Multi SELECT status labels. */
    stringArrayKeys: ['transferStatus'],
};
